import {styled} from "@mui/material/styles"
import {breakpoints, FALLBACK_FONT_FAMILY} from "@next/ux-fabric"

export const Container = styled("div")`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    width: 18rem;
    padding: 1rem;
    background-color: ${({theme}) => theme.uxfabric.background.paper};
    border-radius: 0.25rem;

    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media (min-width: ${breakpoints.values.md}px) {
        width: 35rem;
        height: 13.1875rem;
    }

    @media (max-width: ${breakpoints.values.md}px) {
        align-items: center;
        gap: 0.5rem;
    }
`

export const StyledButtonWrapper = styled("div")`
    display: flex;
    gap: 0.75rem;

    @media (min-width: ${breakpoints.values.md}px) {
        flex-direction: row-reverse;
    }

    @media (max-width: ${breakpoints.values.md}px) {
        width: 100%;
        flex-direction: column;
    }
`

export const StyledButtonContainer = styled("div")`
    letter-spacing: ${({theme}) => theme.uxfabric.component.buttonMedium.letterSpacing}px;
    font-family: ${({theme}) => theme.uxfabric.component.buttonMedium.fontFamily}, ${FALLBACK_FONT_FAMILY};
    font-size: ${({theme}) => theme.uxfabric.component.buttonMedium.fontSize};
    font-weight: ${({theme}) => theme.uxfabric.component.buttonMedium.fontWeight};
    width: 50%;
    height: 2.75rem;
    font-size: 0.75rem;

    @media (max-width: ${breakpoints.values.md}px) {
        width: 100%;
    }
`

export const StyledTextContainer = styled("div")`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    gap: 1rem;
`
